import { memo, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import TourItineraryContent from './TourItineraryContent';
import TourBookingColumn from '../TourBookingColumn';

const TourItinerary = ({
  itinerary,
  tripId,
  tripRoomSearchInput,
  isBookingOpen,
  isBookingDisabled,
  onToggleBooking,
  onMouseEnter,
  onMouseLeave,
  doScrollToTour,
  doHaveBorderAround,
  wrapperClassName,
  doShowPrice,
  doShowAvailabilityButton,
  isExpanded,
}) => {
  const router = useRouter();
  const brochure = useSelector((state) => state.brochure.brochures[tripId]);
  const [isOwnBookingOpen, setIsOwnBookingOpen] = useState(false);
  const doOwnBookingPanel = !onToggleBooking;
  const isPanelOpen = doOwnBookingPanel ? isOwnBookingOpen : isBookingOpen;
  const isBrochurePage = (router?.pathname || '').indexOf('brochure') > -1;
  const doAllowBooking = !isBrochurePage || !!brochure?.doAllowBook;

  const card = (
    <TourItineraryContent
      itinerary={itinerary}
      tripId={tripId}
      doShowAvailabilityButton={doShowAvailabilityButton && doAllowBooking}
      isBookingOpen={isPanelOpen}
      isBookingDisabled={isBookingDisabled}
      onToggleBooking={
        doOwnBookingPanel ? () => setIsOwnBookingOpen((isOpen) => !isOpen) : onToggleBooking
      }
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      doScrollToTour={doScrollToTour}
      doHaveBorderAround={doHaveBorderAround}
      wrapperClassName={wrapperClassName}
      doShowPrice={doShowPrice}
      isExpanded={isExpanded}
    />
  );

  if (!doOwnBookingPanel) {
    return card;
  }

  return (
    <div className={clsx('grid grid-cols-1', { 'md:grid-cols-3 xl:grid-cols-4': isPanelOpen })}>
      <div className={clsx('min-w-0', { 'md:col-span-2 xl:col-span-3': isPanelOpen })}>{card}</div>
      {isPanelOpen && (
        <div className="pt-3 pb-4 pl-5 pr-3">
          <TourBookingColumn
            itinerary={itinerary}
            tripId={tripId}
            tripRoomSearchInput={tripRoomSearchInput}
            doShowPrice={doShowPrice}
          />
        </div>
      )}
    </div>
  );
};

TourItinerary.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string,
  tripRoomSearchInput: PropTypes.arrayOf(PropTypes.shape()),
  isBookingOpen: PropTypes.bool,
  isBookingDisabled: PropTypes.bool,
  onToggleBooking: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  doScrollToTour: PropTypes.bool,
  doHaveBorderAround: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  doShowPrice: PropTypes.bool,
  doShowAvailabilityButton: PropTypes.bool,
  isExpanded: PropTypes.shape({
    value: PropTypes.bool,
  }),
};

TourItinerary.defaultProps = {
  tripId: undefined,
  tripRoomSearchInput: undefined,
  isBookingOpen: false,
  isBookingDisabled: false,
  onToggleBooking: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  doScrollToTour: true,
  doHaveBorderAround: true,
  wrapperClassName: 'px-4 py-3 mb-2 rounded-lg',
  doShowPrice: true,
  doShowAvailabilityButton: true,
  isExpanded: { value: false },
};
export default memo(TourItinerary);
